<div class="error-page">
  <empty-state
    [img]="'./assets/images/404-ErrorPage.svg'"
    [title]="'general.Page not found' | translate"></empty-state>
</div>
